// extracted by mini-css-extract-plugin
export default {"basepageContent":"TitprW_rtsaU_ZwQTGPP-style-basepageContent"};